<template>
    <div class="account">
		<div class="account_header">
			<div class="container-Login">
				<div class="logo_box">
					<img src="../../assets/images/logo/logo_black.png" alt="">
				</div>
			</div>
		</div>
		<div class="account_main">
			<div class="account_container flex">
				<div class="account_wrapper flex">
					<div class="account_left flex">
						<div class="box">
							<div class="img_box">
								<img src="../../assets/images/bg/img.png" alt="" width="100%">
							</div>
						</div>
					</div>
					<div class="account_right flex">
						<div class="box">
							<div class="account_title flex">
								<a class="active">登录</a>
							</div>
							<form action="#">
								<div class="form_item">
									<div class="inputBox"> <!--error-->
										<input type="text" class="input" name="email" autocomplete="off" placeholder="用户名" v-model="account">
										<p class="inputError">请输入正确的帐号</p>
									</div>
								</div>
								<div class="form_item">
									<div class="inputBox">
										<input type="password" class="input" name="password" autocomplete="off" placeholder="密码" v-model="password">
										<p class="inputError">请输入正确的密码</p>
									</div>
								</div>
								<div class="form_item">
									<div class="account_operate">
										<!-- <span class="operate_item">
											<input id="remindPw" type="checkbox">
											<label for="remindPw">记住密码</label>
										</span> -->
										<span class="operate_item">
											<!-- <a href="/find_password">忘记密码？</a> -->
										</span>
									</div>
								</div>
								<div class="btn_box">
									<button type="button" class="btn btn_primary" style="width: 100%;" @click="login()" v-loading="loginStatus">登录</button>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="account_footer">
			<div class="container-Login">
				<div class="flex">
					<span>支持的浏览器有：IE版本9以上，Chrome,Safari,Firefox，国内浏览器请使用极速模式。</span>
					<span>版权所有 &copy; CIMA，<a href="http://www.beian.miit.gov.cn/" target="_balnk">沪ICP备15038274号</a>，技术支持：<a href="http://www.alawang.com" target="_blank">ALA</a></span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import "../../assets/css/login.css";
import $ from 'jquery';
import 'jquery.nicescroll'
export default {
	name:"Login",
	data(){
		return {
			account:'',
			password:'',
			loginStatus:false,
		}
	},
	mounted(){
		$('.account').niceScroll({
			cursorborder: "",
			cursorcolor: "#B1AFB0",
			cursorwidth: "6px",
			autohidemode: false
		});
	},
	methods:{
		login(){
			this.loginStatus=true;
			let that = this;
			let _data = {
				account:this.account,
				password:this.password
			}

			if(_data.account === ''){
				that.loginStatus=false;
				that.$message.error('请输入账号');
				return false;
			}

			if(_data.password === ''){
				that.loginStatus=false;
				that.$message.error('请输入密码');
				return false;
			}
		
			this.$API('/api/login','post',_data,function(response){
				if(response.code === 200){
					let jumpUrl = 'index';
					if(response.data.type===2){
						jumpUrl = 'upload';
					}
					that.$message.success(response.message,'success');
					setTimeout(function(){
						window.localStorage.setItem('token',response.data.token);
						window.location.href=jumpUrl
					});
				}else{
					that.loginStatus=false;
					that.$message.error(response.message);
				}
			},function(){
				
			});
		}
	}
}

</script>